<template>
  <!--    商户信息搜索筛选部分-->
  <div>
    <el-col>
      <el-form :inline="true" class="demo-inline-form" :model="search_sale">
        <el-form-item label="门店编号">
          <el-input
            class="inputWidth"
            v-model="search_sale.shopId"
            placeholder="请输入"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input
            class="inputWidth"
            v-model="search_sale.shopName"
            placeholder="请输入"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="上级机构名称">
          <el-input
            class="inputWidth"
            v-model="search_sale.organizationName"
            placeholder="请输入"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="上级机构编号">
          <el-input
            class="inputWidth"
            v-model="search_sale.organizationId"
            placeholder="请输入"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            class="selectWidth"
            v-model="search_sale.auditStatus"
            placeholder="请选择"
            clearable>
            <el-option label="资料待完善" value="-1"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核不通过" value="1"></el-option>
            <el-option label="审核通过" value="3"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            label="查询"
            @click.native="buttonSearch"
            :loading="checkLoading"></auth-button>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-refresh"
            label="重置"
            @click.native="reset"
            :loading="checkLoading"></auth-button>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-circle-plus-outline"
            label="新增门店"
            @click.native="toAddChainShop"></auth-button>

        </div>
      </el-form>
    </el-col>
    <el-col>
      <div class="tips"></div>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { mccTypeList, mccGroupList } from '@/api/global'
import { queryAllSale, subAgentInfo, exportMerchantList, exportReportMerchantList, exportExpiredMerchant } from '@/api/merchant'
export default {
  name: 'ListSearch',
  components: {
  },
  props: {
    searchLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '1'
    },
    hideExpireExport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchLoading (val, oldVal) {
      this.checkLoading = val
      this.$forceUpdate()
    },
    'search_sale.realMerchantType' (val, oldVal) {
      this.search_sale.merchantType = val > 3 ? 3 : val
      this.search_sale.companyChildType = val >= 3 ? val - 2 : ''
    }
  },
  data () {
    return {
      search_sale: {
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        FMerchantId: '', // 商户编号
        FShopType: '', // 商户类型
        FMerchantName: '', // 商户简称
        FBelongsAgentId: '', // 直属代理商
        // grandpaCode:'',//行业类型
        // FMccCode:'',//行业小类
        merchantType: '', // 商户类型
        FPrivilegeLevel: '', // 商户等级
        FDealState: '', // 交易状态
        FSettleState: '', // 结算状态
        statusCode: '', // 审核状态
        FOperatorAccount: '', // 业务员账号
        companyChildType: '', // 公司子类型
        realMerchantType: '' // 搜索定义 商户类型
      }

    }
  },
  mounted () {
    // this.getMccTypeList()// 获取行业类型
    this.getUserInfo()
    // this.getPrivileges()
    // if (this.roleName !== 'operator') {
    //   this.getSalesList()
    //   this.getAgentsList()
    // }
    // this.buttonSearch()
    // this.agentId = this.$store.getters.userId
  },
  methods: {
    /**
     * @description 获取用户信息
     */
    getUserInfo () {
      this.roleName = this.$store.getters.roleName
    },
    /**
     * @description 设置默认选中的日期
     */
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
    },
    /**
     * @description 获取行业类型
     */
    getMccTypeList () {
      const data = qs.stringify({})
      mccTypeList(data).then(response => {
        if (parseInt(response.error_code) === 0) {
          this.mcc_list = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'warning'
          })
        }
      })
    },
    /**
     * @description 商户等级列表获取
     */
    getPrivileges () {
      var con = JSON.parse(localStorage.privilegeConst)
      var compare = function (obj1, obj2) {
        var val1 = obj1.code
        var val2 = obj2.code
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
      this.effect_privilege_level_list = con.sort(compare)
    },
    /**
     * @description 获取业务员列表方法
     */
    getSalesList () {
      // var data = this.formatSearch(this.sales_search_info);
      // data = qs.stringify(data);
      // 设一个超大的pageSize取所有数据
      queryAllSale('pageSize=65535').then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.sales_info_list = data.list
          this.sales_info_list_back = [...this.sales_info_list]
        }
      })
    },
    /**
     * @description 获取代理商列表方法
     */
    getAgentsList () {
      // var data = this.formatSearch(this.agents_search_info);
      // data = qs.stringify(data);
      // 设一个超大的pageSize取所有数据
      subAgentInfo('pageSize=655350').then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          const userInfo = this.$store.state.user.userInfo.userEntity
          const agentList = [{
            fAgentId: userInfo.fAgentId,
            fTitle: userInfo.fTitle
          }]
          this.agents_search_list = agentList.concat(data.list)
          this.agents_search_list_back = [...this.agents_search_list]
        }
      })
    },
    /**
     * @description 修改行业大类方法
     * @param {String} value 选中的行业大类id
     */
    changeCode (value) {
      this.group_list = []
      this.getGroup(value)
    },
    /**
     * @description 获取行业小类方法
     * @param {String} id 选中的行业大类id
     */
    getGroup (id) {
      if (id) {
        this.group_list = []
        mccGroupList({
          grandpaCode: id
        }).then((data) => {
          if (parseInt(data.error_code) !== 0) {
          } else {
            this.group_list = data.list
          }
        })
      } else {
        this.search_sale.FMccCode = ''
      }
    },
    /**
     * @description 业务员账号自定义筛选方法
     */
    handleSalesInfoFilter (queryString) {
      if (queryString) {
        this.sales_info_list = this.sales_info_list_back.filter(item => {
          return item.fAgentAccount.toLowerCase().includes(queryString.toLowerCase()) || item.fName.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.sales_info_list = this.sales_info_list_back
      }
    },
    /**
     * @description 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.agents_search_list = this.agents_search_list_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.agents_search_list = this.agents_search_list_back
      }
    },
    reset () {
      this.search_sale = this.$options.data().search_sale
      this.$emit('search', this.search_sale)
    },
    buttonSearch () {
      this.$emit('search', this.search_sale)
    },
    toAddChainShop () {
      this.$router.push({
        path: '/Merchant/SoftwareMerchant/addChainShop',
        query: {
          step: 1
        }
      })
    },
    // 导出
    /**
     * @description 点击导出按钮，判断规则是否满足
     */
    buttonExport () {
      if (this.comeTime == null || this.comeTime === '') {
        this.$message({
          showClose: true,
          message: '创建时间区间不能为空，请检查后重试',
          type: 'warning'
        })
        return
      }
      // var startDate = new Date(this.comeTime[0]);
      // var endDate = new Date(this.comeTime[1]);
      // if(startDate.getMonth() == endDate.getMonth()){
      //     var yearNum=startDate.getFullYear();
      //     var monthNum = startDate.getMonth();
      //     monthNum = monthNum + 1
      //     var tmpDate = new Date(yearNum,monthNum,0);
      //     if((endDate.getTime()-startDate.getTime())/( 1000 * 3600 * 24) > tmpDate.getDate()){
      //         this.$message({
      //             showClose: true,
      //             message: "导出时间不能超过一个月，请检查后重试",
      //             type: 'warning'
      //         });
      //         return;
      //     }
      // }else{
      //     if((endDate.getTime()-startDate.getTime())/( 1000 * 3600 * 24) > 30){
      //         this.$message({
      //             showClose: true,
      //             message: "导出时间不能超过一个月，请检查后重试",
      //             type: 'warning'
      //         });
      //         return;
      //     }
      // }

      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      this.exportList()
    },
    /**
     * @description 导出方法
     */
    exportList () {
      this.exportLoading = true
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)
      if (this.type === '1') {
        exportMerchantList(data).then(response => {
          this.exportLoading = false
          // 弹出下载框
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '商户信息.csv')
          document.body.appendChild(link)
          link.click()
        }).catch(() => {
        })
      } else {
        exportReportMerchantList(data).then(response => {
          this.exportLoading = false
          // 弹出下载框
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '商户申请记录.csv')
          document.body.appendChild(link)
          link.click()
        }).catch(() => {
        })
      }
    },
    /**
     * @description 清除对象中无值属性
     */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 导出证件过期商户列表
    exportExpiredMerchant () {
      this.exportExpiredLoading = true
      const nowDate = new Date()
      const timeString = nowDate.getFullYear() + '' +
        (((nowDate.getMonth() + 1) < 10) ? ('0' + (nowDate.getMonth() + 1)) : (nowDate.getMonth() + 1)) +
        ((nowDate.getDate() < 10) ? ('0' + nowDate.getDate()) : (nowDate.getDate())) +
        ((nowDate.getHours() < 10) ? ('0' + nowDate.getHours()) : (nowDate.getHours())) +
        ((nowDate.getMinutes() < 10) ? ('0' + nowDate.getMinutes()) : (nowDate.getMinutes())) +
        ((nowDate.getSeconds() < 10) ? ('0' + nowDate.getSeconds()) : (nowDate.getSeconds()))

      exportExpiredMerchant({}).then(response => {
        this.exportExpiredLoading = false
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const fileName = '证件过期商户_' + this.agentId + '_' + timeString
        link.setAttribute('download', fileName + '.csv')
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
      })
    },
    importSubmit (result) {
      if (result) {
        this.buttonSearch()
      }
    }
  }
}
</script>

<style scoped>
  .review-return-tips-button {
    display: inline-block;
    color: #1e90ff;
    cursor: pointer;
    margin: 10px 5px;
  }
  .selectWidth{
    width: 150px;
  }
  .batchImport{
    margin-left: 10px;
  }
  .tips {
    color: #C0C4CC;
    margin: 10px 5px;
    font-size: 14px;
  }
</style>
